// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1KOzK","label":"LabeledBox_label__1kk-y"};